type TableOpenedPayload = {
  event: 'table_opened'
  data: {
    mesa_id: number
    user_id: number
    user_name: string
    time_used: string | null
    time_last_order: string | null
  }
}

type TableClosedPayload = {
  event: 'table_closed'
  data: {
    mesa_id: number
  }
}

type TableEventPayload = TableOpenedPayload | TableClosedPayload

export function updateSalones(
  mesaId: number,
  payload: TableEventPayload,
  setSalones: any
) {

  console.log('[updateSalones] Updating salones for mesa:', mesaId, 'event:', payload.event);
  
  // Ignore WebSocket table_closed events for mesas that were just payment-completed
  if (payload.event === 'table_closed') {
    const recentlyCompleted = (window as any).__recentlyPaymentCompleted || new Map();
    const completionTime = recentlyCompleted.get(mesaId);
    if (completionTime && Date.now() - completionTime < 2000) {
      console.log('[updateSalones] IGNORING table_closed for mesa', mesaId, '- recently payment-completed');
      return;
    }
    // Clean up old entries
    recentlyCompleted.delete(mesaId);
  }

  setSalones((prev:any) =>
    prev.map((salon:any) => ({
      ...salon,
      mesas: salon.mesas.map((mesa:any) => {
        // NOTE: match on mesa.id (not mesa.mesa_id)
        if (mesa.id !== mesaId) return mesa

        console.log('[updateSalones] Found mesa to update:', mesa.id, 'event:', payload.event);

        if (payload.event === 'table_opened') {
          const { user_id, user_name, time_used, time_last_order } = payload.data
          return {
            ...mesa,
            used: true,
            charged: false,
            user_id,
            user_name,
            time_used,
            time_last_order,
            total_charges: 0,
          }
        }

        const mesasPaymentCache = JSON.parse(localStorage.getItem('mesasPaymentCache') || '{}');
        const newPaid = mesasPaymentCache[mesaId]?.paidPersons + 1;
        // update cache
        mesasPaymentCache[mesaId] = {
          ...mesasPaymentCache[mesaId],
          paidPersons: newPaid,
        }
        localStorage.setItem('mesasPaymentCache', JSON.stringify(mesasPaymentCache))

        if (payload.event === 'table_closed') {
        // delete the cache entry for this mesa
          delete mesasPaymentCache[mesaId]
          localStorage.setItem('mesasPaymentCache', JSON.stringify(mesasPaymentCache))

          return {
            ...mesa,
            used: false,
            charged: false,
            user_id: null,
            user_name: null,
            time_used: null,
            time_last_order: null,
            is_merged:false,
            parent_mesa_id: null,
            total_charges: 0,
            current_people: 0,
          }
      } else {
        // update mesasPaymentCache
        mesasPaymentCache[mesaId] = {
          ...mesasPaymentCache[mesaId],
          paidPersons: newPaid,
        }
        localStorage.setItem('mesasPaymentCache', JSON.stringify(mesasPaymentCache))
        return mesa
      }
      }),
    }))
  )
}
